<script setup>
import { computed, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed (Two-way binding for Vuex) ---

const navSearch = computed({
    get() {
        return store.state.themes.navSearch;
    },
    set(value) {
        store.commit('themes/navSearch', value);
    }
});
</script>

<template>
    <div class="position-relative mx-1 flex-fill">
        <i class="bi bi-search position-absolute top-50 start-0 translate-middle-y text-muted ps-2 small"></i>
        <input
            v-model="navSearch"
            type="text"
            class="form-control form-control-sm rounded-5 h-25"
            style="padding-left: 28px; min-height: auto; font-size: 12px"
        >
        <i
            v-if="navSearch !== ''"
            @click="navSearch = ''"
            class="bi bi-x position-absolute top-50 end-0 translate-middle-y text-muted pe-2"
            role="button"
        ></i>
    </div>
</template>